import React, { useEffect, useState } from "react";
import MobNavbar from "../custom/MobNavbar";
import Navbar from "../custom/Navbar";
import "./ContactUs.css";
import Form from "./layout/Form";
import Maps from "./layout/Maps";


function ContactUs(props) {
  return (
    <div style={{backgroundColor: props.darkMode?"rgb(17 24 39)":"darkcyan"}}>
    {/*<h2 className="hire-me" style={{marginLeft: "70px",fontWeight: "bolder",marginTop: "30px", color: "white" , fontSize: "50px"}}>Contact Me</h2>*/}
    <div className="contactus">
      <Form />
      <Maps />
    </div>
    </div>
  );
}

export default ContactUs;
